import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { MapElementSelector } from '../../selector/MapElementSelector';
import { formatTreeParameter } from "../../../../../shared/helper/actionTreeHelper";
import { editorMapStore, MapStatus } from '../../../../stores/EditorMapStore';
import { sharedStore } from '../../../../stores/SharedStore';
import styled from 'styled-components';
import { getTreeParentOfClosestActionModel } from '../../../../../shared/action/ActionTreeModel';
import { ElementParameter } from '../../../editor/ElementIcons';
import { getImageForElement } from '../../../../helper/mapElementIconHelper';
import { ElementGroup, ElementLabel } from './BaseElements';
const InfoContainer = styled.div.withConfig({
  displayName: "AnimationElementWithRequiredAnimationsSelectionDetail__InfoContainer",
  componentId: "sc-kgauz2-0"
})(["margin:4px;font-size:small;max-width:250px;"]);
export const AnimationElementWithAnimationRestrictionsSelectionDetail = observer(({
  name,
  selectedAnimationElement,
  animationElementSetter,
  requiredAnimationNames,
  allowBlankValue
}) => {
  const {
    t
  } = useTranslation();
  const parentTree = getTreeParentOfClosestActionModel(selectedAnimationElement, true);
  const animationElementTreeParameters = parentTree.treeParameterActions("actions/AnimationElementValueModel");
  const fittingParameters = animationElementTreeParameters.filter(parameter => {
    const valueInstance = parameter.value;
    return valueInstance.hasRequiredAnimationNames && fitsAnimationRequirements(requiredAnimationNames, valueInstance.requiredAnimationNames);
  }).map(parameter => formatTreeParameter(parameter.name));

  const getElements = mapId => {
    if (mapId === 0) {
      return {
        mapStatus: MapStatus.Loaded,
        mapName: undefined,
        elements: fittingParameters.map(parameter => ({
          id: parameter,
          label: parameter,
          icon: /*#__PURE__*/React.createElement(ElementParameter, {
            key: parameter
          })
        }))
      };
    }

    const {
      map,
      mapStatus
    } = editorMapStore.getOrLoadMapWithMetaData(mapId, true);
    const animationElements = map ? map.animationElements : [];
    const fittingAnimations = animationElements.filter(element => {
      const animation = sharedStore.getAnimationByName(element.animationName);
      return animation && fitsAnimationRequirements(requiredAnimationNames, animation.animationNames);
    });
    return {
      mapStatus,
      mapName: map === null || map === void 0 ? void 0 : map.properties.name,
      elements: fittingAnimations.map(a => ({
        id: a.$modelId,
        label: a.label === "" ? a.animationName : a.label + ` (${a.animationName})`,
        image: getImageForElement(a)
      }))
    };
  };

  return /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(ElementLabel, null, name), /*#__PURE__*/React.createElement(InfoContainer, null, "(", t("action_editor.property_required_animation_sequences"), ": ", requiredAnimationNames.join(", "), ")"), /*#__PURE__*/React.createElement(MapElementSelector, {
    selectedElement: selectedAnimationElement,
    elementSetter: animationElementSetter,
    elementsGetter: getElements,
    allowBlankValue: allowBlankValue
  }));
});

function fitsAnimationRequirements(requiredAnimations, hasAnimation) {
  return requiredAnimations.every(requiredAnimation => hasAnimation.some(animation => animation === requiredAnimation));
}